import { render, staticRenderFns } from "./ModalCampaignTypeSelector.vue?vue&type=template&id=9a0437ba&scoped=true&"
import script from "./ModalCampaignTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ModalCampaignTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0437ba",
  null
  
)

export default component.exports